import axios from 'axios'
import {
  BaeimSDK,
  SyncOptions,
} from 'baeim-sdk_beta'
import {
  Channel,
  ConnectStatus,
} from 'wukongimjssdk'

import { getIMToken } from '@/utils/api'
import { sleep } from '@/utils/sleep'

let currentSDK: BaeimSDK | undefined = undefined
let currentUserId: number | undefined = undefined
let currentToken: string | undefined = undefined

export const waitForSDK = async ({ userId }: { userId: number }) => {
  let maxTime = 500
  while (maxTime >= 0) {
    if (currentUserId === userId && currentSDK?.status === ConnectStatus.Connected) {
      return currentSDK
    }
    await sleep(0.1)
    maxTime--
  }

  return undefined
}

export interface CreateBaeIMSdkParams {
  userId: number
  token: string
  onCreated: (sdk: BaeimSDK) => void
}

export const clearBaeIMSdk = () => {
  if (currentSDK) {
    currentSDK.removeMessageListener()
    currentSDK.stop()
  }
  currentSDK = undefined
  currentUserId = undefined
  currentToken = undefined
}

export const createBaeIMSdk = ({
  userId,
  token,
  onCreated,
}: CreateBaeIMSdkParams) => {
  if (currentSDK && currentUserId === userId && currentToken === token) {
    return currentSDK
  }
  if (currentSDK) {
    currentSDK.removeMessageListener()
    currentSDK.stop()
  }
  currentUserId = userId
  currentToken = token.replace('Bearer ', '')
  currentSDK = new BaeimSDK({
    token: currentToken, // 当前登录用户的token
    userUid: String(userId), // 当前用户的tgid
    serverAddr: 'wss://c.bae.boo/ws', // IM服务的websocket地址
    syncMessagesCallback: async (
      { channelID, channelType }: Channel,
      { startMessageSeq, endMessageSeq, pullMode, limit }: SyncOptions,
    ) => {
      const { data } = await axios.post('https://c.bae.boo/channel/messagesync', {
        uid: String(userId),
        channel_id: channelID,
        channel_type: channelType,
        start_message_seq: startMessageSeq,
        end_message_seq: endMessageSeq,
        pull_mode: pullMode,
        limit,
        login_uid: String(userId),
      }, {
        headers: { token: getIMToken() },
      })
      return data.messages
    },
    syncConversationsCallback: async () => {
      const { data } = await axios.post('https://c.bae.boo/conversation/sync', {
        uid: String(userId),
        msg_count: 30,
      }, {
        headers: { token: getIMToken() },
      })
      return data
    },
  })
  onCreated(currentSDK)
  return currentSDK
}
